import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from "@angular/material/expansion";
import { MailTemplate, MailTemplateType, ModalService, Request } from 'npx-family-happy-common';
import { catchError, map, of, Subject, takeUntil } from 'rxjs';
import { TextEditorWrapperComponent } from 'src/app/shared/components/text-editor/text-editor-wrapper/text-editor-wrapper.component';
import { RequestMessage } from 'src/app/shared/models/message.model';
import { FormControlPipe } from "../../../../shared/pipes/form-control.pipe";
import * as juice from 'juice';
import { RequestService } from 'src/app/requests-handling/request-service/request.service';
import { RouterStateManagerService } from 'src/app/shared/services/router-state-manager/router-state-manager.service';
import { RequestMessagesTemplatingService } from 'src/app/requests-handling/request-messages-templating/request-messages-templating.service';

@Component({
  selector: 'app-request-partner-messages',
  standalone: true,
  imports: [CommonModule, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, ReactiveFormsModule, TextEditorWrapperComponent, FormControlPipe],
  templateUrl: './request-partner-messages.component.html',
  styleUrl: './request-partner-messages.component.scss'
})
export class RequestPartnerMessagesComponent implements OnInit {

  @Input() requestID!: number;

  paymentURL = '';
  messages!: UntypedFormGroup;
  private unsubscribe = new Subject<void>();
  requestMessages!: RequestMessage[];
  temporaryTemplate: MailTemplate[] = []
  updateAd: boolean = false;
  request!: Request;

  sections = [
    {
      id: 2,
      title: 'Email Preventivo',
      visible: false,
      subject: 'preventivo'
    }
  ];
  step = -1;

  constructor(private modalService: ModalService, private requestService: RequestService, private stateManager: RouterStateManagerService,
    private messageTemplatingService: RequestMessagesTemplatingService) {
    this.formInitializer();
  }

  ngOnInit(): void {

    this.stateManager.getRequestState()
      .pipe(takeUntil(this.unsubscribe),
        map((state) => {
          if (state.request) {
            this.request = state.request;
          }
        }),
        catchError((err) => {
          console.error(err);
          return of(null);
        })
      ).subscribe()

    this.messageTemplatingService.getProcessedTemplates()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((templates) => {
        this.temporaryTemplate = templates
        this.initForm(templates)
      }
      );
  }

  private initForm(templates: MailTemplate[]) {
    if (templates.length > 0) {
      const quoteTemplate = templates.find(item => item.type === MailTemplateType.QUOTATION);
      this.messages.setValue({
        preventivo: quoteTemplate?.subject,
        2: quoteTemplate?.text,
      });
    } else {
      this.messages.setValue({
        preventivo: '',
        2: '',
      });
    }

  }

  formInitializer() {
    this.messages = new UntypedFormGroup({
      preventivo: new UntypedFormControl(''),
      2: new UntypedFormControl(''),
    });
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.paymentURL);
    this.modalService.showSuccessMessage('Link di pagamento copiato con successo! Ora puoi incollarlo dove vuoi.');
  }

  createPaymentLink() {
    this.messageTemplatingService.updatePaymentUrl().pipe(takeUntil(this.unsubscribe)).subscribe((value) => {
      let paymentUpdate = value
      if (paymentUpdate !== '') {
        this.paymentURL = paymentUpdate;
        this.modalService.showSuccessMessage(`Link di pagamento aggiornato correttamente.`);
      } else {
        this.modalService.showErrorMessage(`Impossibile aggiornare link di pagamento`);
      }
    })
  }

  getSectionTitle(section: number) {
    let text = '';

    let whatsApp = this.requestMessages ? this.requestMessages.filter(messages => messages.type === 'Whatsapp Broadcast').sort((a, b) => Number(new Date(a.sentTimestamp)) - Number(new Date(b.sentTimestamp))) : [];
    let mailTate = this.requestMessages ? this.requestMessages.filter(message => message.type === 'Email Tate').sort((a, b) => Number(new Date(a.sentTimestamp)) - Number(new Date(b.sentTimestamp))) : [];
    let mailPreventivo = this.requestMessages ? this.requestMessages.filter(message => message.type === 'Email Preventivo').sort((a, b) => Number(new Date(a.sentTimestamp)) - Number(new Date(b.sentTimestamp))) : [];
    let mailProfili = this.requestMessages ? this.requestMessages.filter(message => message.type === 'Email Invio Profili').sort((a, b) => Number(new Date(a.sentTimestamp)) - Number(new Date(b.sentTimestamp))) : [];
    let mailCellulare = this.requestMessages ? this.requestMessages.filter(message => message.type === 'Email Cellulare').sort((a, b) => Number(new Date(a.sentTimestamp)) - Number(new Date(b.sentTimestamp))) : [];

    if (!this.requestMessages) {
      return this.sections[section].title;
    }
    switch (section) {
      case 0:
        text = !(whatsApp.length > 0) ? this.sections[section].title : this.sections[section].title + ' - Inviato il ' + new Date(whatsApp[whatsApp.length - 1].sentTimestamp).toLocaleDateString();
        break;
      case 1:
        text = !(mailTate.length > 0) ? this.sections[section].title : this.sections[section].title + ' - Inviata il ' + new Date(mailTate[mailTate.length - 1].sentTimestamp).toLocaleDateString();
        break;
      case 2:
        text = !(mailPreventivo.length > 0) ? this.sections[section].title : this.sections[section].title + ' - Inviata il ' + new Date(mailPreventivo[mailPreventivo.length - 1].sentTimestamp).toLocaleDateString();
        break;
      case 3:
        text = !(mailProfili.length > 0) ? this.sections[section].title : this.sections[section].title + ' - Inviata il ' + new Date(mailProfili[mailProfili.length - 1].sentTimestamp).toLocaleDateString();
        break;
      case 4:
        text = !(mailCellulare.length > 0) ? this.sections[section].title : this.sections[section].title + ' - Inviata il ' + new Date(mailCellulare[mailCellulare.length - 1].sentTimestamp).toLocaleDateString();
        break;
      default:
        text = this.sections[section].title;
        break;
    }
    return text;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  setStep(step: number) {
    this.step = step;
  }

  sendMessage(section: any, index: number) {
    try {
      this.modalService.showLoadingWithMessage('Invio in corso...');
      const subjectField: string = this.sections.find(item => item.id === section)?.subject || '';
      const messageWithStyle = '<style>p, li {font-size:16px; margin:0px;} .ql-size-small{font-size: 12px;} body, p, span, li, strong, em {font-family: Verdana, sans-serif;}</style>' + this.messages.get('' + section)?.value
      const messageBody = juice(messageWithStyle)
      this.requestService.sendMessage(section, this.messages.get(subjectField)?.value, messageBody, this.request.requestPersonalInfo.provincia, this.updateAd);
    } catch (err) {
      this.modalService.showErrorMessage(`Si è verificato un errore nell'invio della mail.`);
    } finally {
      this.updateAd = true;
    }
  }


}
